import React from 'react';
import PropTypes from 'prop-types';

import {
  DropdownBase,
  DropdownTrigger
} from '@cybs-ui/components/lib/advanced-dropdown';

const CHDDBase = ({ filters, type, labelKey, active, ...props }) => {
  let label = filters.length > 0 ? filters[0][labelKey] : 'Select Items';
  if (type === 'multiselect') {
    label = `${filters.length} option${
      filters.length === 1 ? '' : 's'
    } selected`;
  }
  return (
    <DropdownBase
      itemToString={item => (item ? item.label : '')}
      labelKey={labelKey}
      {...props}
    >
      {triggerProps => (
        <DropdownTrigger
          focusRef={props.focusRef}
          {...triggerProps}
          elementType="column-header"
          elementLabel={label || 'Select multiple items'}
          elementProps={{
            active,
            icon: 'list-view'
          }}
        />
      )}
    </DropdownBase>
  );
};

CHDDBase.defaultProps = {
  filters: [],
  type: '',
  labelKey: '',
  active: false,
  focusRef: null
};

CHDDBase.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.any),
  type: PropTypes.string,
  labelKey: PropTypes.string,
  active: PropTypes.bool,
  focusRef: PropTypes.oneOf([PropTypes.func, PropTypes.node, PropTypes.element])
};

CHDDBase.displayName = 'ColumnHeaderDropdownBase';

export default CHDDBase;
